import Generator from './Generator';
import {scramble,descramble} from './scrambler';
import MAX_U32 from './MaxU32';

const arbitrary = {
    MAX_U32,
    Generator,
    scramble,
    descramble
};

export default arbitrary;
